import { useI18nStore } from '../../lib/i18n';
const tt = (k, p) => useI18nStore.getState().t(`startStopAdmin.${k}`, p);
export const LEG_COLORS = { depot_start: '#6366f1', start_stop: '#10b981', stop_depot: '#f43f5e' };
export const mapsUrl = (p) => `https://www.google.com/maps?q=${p.lat},${p.lng}`;
const LOCALES = { tr: 'tr-TR', en: 'en-GB', nl: 'nl-BE', fr: 'fr-BE' };
export const loc = () => LOCALES[useI18nStore.getState().language] || 'tr-TR';
export const fmtD = (s) => new Date(`${s}T00:00:00`).toLocaleDateString(loc(), { day: '2-digit', month: 'short' });
export const fmtLong = (s) => new Date(`${s}T00:00:00`).toLocaleDateString(loc(), { weekday: 'long', day: 'numeric', month: 'long' });
export const dur = (m) => (m == null ? '—' : tt('dur', { h: Math.floor(m / 60), m: String(m % 60).padStart(2, '0') }));
const STATE_RAW = {
  stopped: ['stStopped', 'bg-emerald-100 text-emerald-700', 'bg-emerald-500'],
  started: ['stStarted', 'bg-sky-100 text-sky-700', 'bg-sky-500'],
  not_started: ['stPending', 'bg-amber-100 text-amber-700', 'bg-amber-400'],
  missing: ['stMissing', 'bg-rose-100 text-rose-700', 'bg-rose-500'],
};
export const STATE = Object.fromEntries(Object.keys(STATE_RAW).map((k) => [k, null]));
Object.keys(STATE_RAW).forEach((k) => Object.defineProperty(STATE, k, { get: () => [tt(STATE_RAW[k][0]), STATE_RAW[k][1], STATE_RAW[k][2]] }));
const fmtVal = (v) => (v === true ? tt('yes') : v === false ? tt('no') : v);
const LEGACY = [['stop_count', 'lgStop'], ['remaining_stops', 'lgRemaining'], ['remaining_packages', 'lgPackages'], ['pickup_packages', 'lgPickup'], ['note', 'lgNote']];
export const answersOf = (r, ph) => {
  const p = r[ph];
  if (!p) return [];
  const ans = p.answers || {};
  const custom = (r.custom_fields || []).filter((f) => f.ss_phase === ph && ans[f.key] != null).map((f) => [f.label, fmtVal(ans[f.key])]);
  const legacy = LEGACY.filter(([k]) => p[k] != null && p[k] !== '').map(([k, l]) => [tt(l), p[k]]);
  return [...legacy, ...custom];
};
export const filesOf = (r) => [
  r.start?.km_photo && { ...r.start.km_photo, label: tt('startKm') }, r.stop?.km_photo && { ...r.stop.km_photo, label: tt('endKm') },
  ...Object.values(r.start?.photos || {}), ...Object.values(r.stop?.photos || {}), ...((r.stop?.attachments) || []),
].filter(Boolean);
